import {EmptyResponseDraftValueObject} from './EmptyResponseDraftValueObject.js'

export class SuccessResponseDraftValueObject extends EmptyResponseDraftValueObject {}
